import {ContextObject} from '../context-object'
import {DataObjectId} from 'yougile-model'

/**
 * @description
 * Gives access to the generic application events:
 * user pressed a key,
 * user went to another tab in browser,
 * user clicked somewhere, …
 * @descriptionRu
 * Дает доступ к базовым событиям приложения:
 * пользователь нажал на кнопку,
 * пользователь перешел на другую вкладку браузера,
 * пользователь куда-нибудь кликнул, …
 */
export class Events extends ContextObject {
  public static shiftPressed = false
  public static altPressed = false
  public static ctrlPressed = false
  public static metaPressed = false

  public static override registered: Map<DataObjectId, Map<string, Events>> =
    new Map()

  /**
   * @code
   * Events.isShiftPressed();
   */
  public isShiftPressed(): boolean {
    return Events.shiftPressed
  }

  /**
   * @code
   * Events.isCtrlPressed();
   */
  public isCtrlPressed(): boolean {
    return Events.ctrlPressed
  }

  /**
   * @code
   * Events.isAltPressed();
   */
  public isAltPressed(): boolean {
    return Events.altPressed
  }

  /**
   * @code
   * Events.isMetaPressed();
   */
  public isMetaPressed(): boolean {
    return Events.metaPressed
  }

  /**
   * @code
   * Events.onKeyDown = function (event) {
   *   if (event.keyCode === '...') {
   *
   *   }
   * }
   */
  public onKeyDown?: (e: KeyboardEvent) => void

  /**
   * @code
   * Events.onKeyUp = function (event) {
   *   if (event.keyCode === '...') {
   *
   *   }
   * }
   */
  public onKeyUp?: (e: KeyboardEvent) => void

  /**
   * @code
   * Events.onClick = function (event) {
   *
   * }
   */
  public onClick?: (e: MouseEvent) => void
}
